<div class="duplicate-warning">
	<p>This {{tickets[0].ticketMode!}} appears to already exist</p>
	<p>Below are the existing {{tickets[0].ticketMode!}}s that match this {{tickets[0].ticketMode!}}s details:</p>

	<nz-table
		[nzBordered]="true"
		[nzData]="tickets"
		[nzFrontPagination]="false"
		[nzShowPagination]="false">
		<thead>
			<tr>
				<th>Assigned To</th>
				<th>Type</th>
				<th>Membership</th>
				<th>Member Details</th>
				<th>ID/Passport Number</th>
				<th>Category</th>
				<th>Status</th>
				<th>Last Action At</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let ticket of tickets; let i = index">
				<td *ngIf="!ticket.assignedToAgent">-</td>
				<td *ngIf="ticket.assignedToAgent">{{ ticket.assignedToAgent.firstName}}</td>
				<td>{{ ticket.workflowLabel }}</td>
				<td>{{ ticket.membership?.membershipNumber??'-' }}</td>
				<td>{{ ticket.member.surname }} {{ticket.member.name}}</td>
				<td>{{ ticket.member.idNumber }}</td>
				<td>{{ ticket.membership?.category??'-' }}</td>
				<td>{{ ticket.currentStepAndStateLabel }}</td>
				<td>{{ ticket.lastActionedAt | date }}</td>
			</tr>
		</tbody>
	</nz-table>



	<p>Please confirm if you want to continue.</p>

	<div class="footer">
		<button nz-button nzType="default" (click)="cancel()">Cancel</button>
		<button nz-button nzType="primary" (click)="continue()">Continue</button>
	</div>
</div>
